import { ButtonHTMLAttributes, forwardRef } from 'react';

import { cn } from './cn';

export interface OptionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

/** One choice in a row of mutually exclusive options. */
export const OptionButton = forwardRef<HTMLButtonElement, OptionButtonProps>(
  ({ className, role, selected = false, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      role={role}
      // Radios and checkboxes use aria-checked from the caller; toggles use pressed.
      aria-pressed={role === 'radio' || role === 'checkbox' ? undefined : selected}
      className={cn(
        'inline-flex h-8 w-full min-w-0 items-center justify-center gap-1.5 truncate rounded-auditor',
        'border px-3 text-xs font-medium transition-colors',
        'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2',
        'disabled:pointer-events-none disabled:opacity-50',
        selected
          ? 'border-brand bg-brand text-ink-inverse'
          : 'border-line-strong bg-surface text-ink hover:border-brand hover:bg-brand-subtle hover:text-brand',
        className,
      )}
      {...props}
    />
  ),
);
OptionButton.displayName = 'OptionButton';
